export default __webpack_public_path__ + "static/AktivGroteskBold-9446e61d161ca20e0e1783709aaee498.woff";